import { useModals } from '@mattjennings/react-modal-stack';
import PromotionModal from './PromotionModal';
import { usePromotions } from '@/store';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';

const usePromotionForm = () => {
  const { openModal, closeModal } = useModals();
  const { promotions, clearPromotion } = usePromotions();
  const { clickedOnPromotionButton } = useAnalyticsEvents();

  const open = () => {
    clickedOnPromotionButton();
    openModal(PromotionModal);
  };

  const close = () => {
    closeModal();
  };

  const getItemDiscount = (price, ticketTypeId) => {
    if (promotions) {
      if (
        promotions.valid_for_ticket_type === 'all' ||
        promotions.valid_for_ticket_type === ticketTypeId.toString() ||
        promotions?.valid_for_ticket_type_list?.includes(ticketTypeId)
      ) {
        if (promotions.discount_type === 'percentage') {
          return price - (promotions.discount_amount / 100) * price;
        }
        if (promotions.discount_type === 'flat') {
          return price - promotions.discount_amount;
        }
        if (promotions.discount_type === 'bundle') {
          const [total, payed] = promotions.bundle_rule.split('x');
          return price * (payed / total);
        }
      }
    }
    return 0;
  };

  return {
    open,
    close,
    promotions,
    clearPromotion,
    getItemDiscount,
  };
};

export default usePromotionForm;
